<div class="info-box">
    <img class="icon" data-cy="icon-image" [src]="imageSrc()" />
    <h3 class="title sir-text-style-paragraph-l-bold" data-cy="title">{{ title() }}</h3>
    <p class="description sir-text-style-paragraph-m-default" data-cy="description">{{ description() }}</p>
</div>
